import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Transaction } from '@fry/payments/lib';
import { TracksOperationProgress } from '@fry/components/common';
import { PaymentComponentState } from './payment.component.state';

/**
 * Transaction payment outcome
 *
 * This component is currently used for multiple purposes:
 * - Informs user who paid by card about the status and allows receipt download.
 * - Informs use who paid by offline method about the status
 * - If transaction is using offline methods which has not been paid yet
 *   user can change payment method
 * - Component displays refunds for the transaction (if any)
 */
@Component({
    selector: 'eas-payments-outcome',
    templateUrl: './transaction.outcome.component.html',
    standalone: false
})
export class TransactionOutcomeComponent implements TracksOperationProgress {

    @Input() isOperationInProgress = false;
    @Input() state!: PaymentComponentState;
    @Input() transaction!: Transaction;
    @Output() cancel = new EventEmitter<void>();
    @Output() refund = new EventEmitter<Transaction>();
    @Output() download = new EventEmitter<void>();

    constructor() { }

    public onNotPaid() {
        this.cancel.emit();
    }

    public onRefund(index: number) {
        const refund = this.transaction.refunds[index];
        if (!this.canPerformActionForRefund(refund)) {
            return;
        }

        this.refund.emit(refund);
    }

    public onDownload() {
        this.download.emit();
    }

    public canPerformActionForRefund(refund: Transaction): boolean {
        return this.state.userHasCapturePermission &&
               !this.state.userIsOwner &&
               !refund.isSettled;
    }
}
